import React, { useState,useEffect } from "react";
import { API_URL,RESPONSE_SUCCESS } from '../../GlobalConstents.js';
import { Link, useNavigate,useParams } from "react-router-dom";
import API from '../../Api.js';
import { toast } from 'react-toastify';
import { ROUTE_DASHBOARD } from '../../RouteConstents.js';
//import { TimeupModal } from '../../Elements/TimeupModal.js';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {RouteChanged,ROUTE_EXAM_SINGLE_REPORT } from '../../RouteConstents';


const ExamPage = () => {
    
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [examTitle, setExamTitle] = useState('');
    const [totalQuestionCount, setTotalQuestionCount] = useState(0);
    const [questionList, setQuestionList] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(1);
    const [showNavigationView, setShowNavigationView] = useState(0);
    const [selectedOption, setSelectedOption] = useState([]);
    const [testID, setTestID] = useState(0);
    const [testReportID, setTestReportID] = useState(0);
    const [takenTime, setTakenTime] = useState();
    const [loadQuestion, setLoadQuestion] = useState(false);
    // const [count, setCount] = useState(0); // seconds

    const [isComplete, setIsComplete] = useState(false);


    const [uncheckClass, setUncheckClass] = useState('');

    const { string } = useParams();
    
    const QuestionPerPage = 1; // Set the number of items per page
    
    useEffect(
        () => {
        document.body.classList.add('theme-red');
        document.body.classList.remove('login-page');
        document.body.classList.remove('overlay-open');
        LoadTestSeriesListOngoing()
    },[]); 

    const totalPages = Math.ceil(totalQuestionCount / QuestionPerPage);

    const LoadTestSeriesListOngoing = async () => {
        setIsLoading(true);
        let objValue =  {"method_name":"runningExam","exam_id":string,"exam_view":1}
        
        await API.post(API_URL,objValue).then(function (response) {
            setIsLoading(false);
            if (response.status === RESPONSE_SUCCESS) {
                if (response.data.status === "success") {
                    setExamTitle(response.data.examInfo.test_series_title)   
                    setTotalQuestionCount(response.data.examInfo.total_questions)
                    // setQuestionList(response.data.examInfo.question_list)
                    setTestID(response.data.examInfo.test_series_id)
                    setTestReportID(response.data.examInfo.test_report_id)
                    setTakenTime(60 * response.data.examInfo.total_time)
                    
                    let questionList = response.data.examInfo.question_list;
                    let optionArr = [];
                    let test_id = response.data.examInfo.test_series_id;

                    questionList.map( (item,key) => {
                        optionArr[key] = {'test_id':test_id,'question_id':item.question_id,'option_id':''};    
                        setSelectedOption(optionArr);

                        let qSr = key + 1;  
                        questionList[key]['question_sr_no'] = qSr;
                        questionList[key]['test_id'] = test_id;
                        questionList[key]['user_select_option'] = '';
                        
                    });

                    setQuestionList(questionList); 
                    setLoadQuestion(true)
                } else {
                    toast.error(response.data.message);
                }
            }

        }).catch(function (error) {
           // ForceLogoutUser(error);
        });

    }

    const goToQuestion = (value) => {
        document.body.classList.remove('overlay-open');
        setShowNavigationView(0); 
        setCurrentQuestion(value);
    }

    const showNavigation = (e) => {
        if(showNavigationView === 0) {
            document.body.classList.add('overlay-open');
            setShowNavigationView(1);
        } else {
            document.body.classList.remove('overlay-open');
            setShowNavigationView(0); 
        } 
    }

    const startIndex = (currentQuestion - 1) * QuestionPerPage;
    const endIndex = startIndex + QuestionPerPage;
    const currentQuestionData = questionList.slice(startIndex, endIndex);

    
    const handlePageChange = (page) => {
        if (page < 1) {
            setCurrentQuestion(1);
        } else if (page > totalPages) {
            setCurrentQuestion(totalPages);
        } else {
            setCurrentQuestion(page);
        }
    };

    const tickAsMark = (questionId,OptionId) => {
        questionList.map( (item,key)=> {
            if(item.question_id === questionId) {
                questionList[key]['user_select_option'] = OptionId; 
            } else {
                questionList[key] = item;     
            }
        });

        setUncheckClass('label_uncheck_'+questionId);
       
        setQuestionList(questionList); 
    }

    const checkSelectOption = (questionId,OptionId) => {
        selectedOption.map( (item,key)=> {
            if(item.question_id === questionId && item.option_id === OptionId) {
                const updatedResponses = {
                    ...selectedOption,
                    [key]: OptionId,
                  };
                  setSelectedOption(updatedResponses);       
            }
        });
        return false;
    }    
    
    const completeExam  = async () => {
        setIsComplete(true);
        let objValue =  {
            "method_name":"completeExam",
            "test_id":testID,
            "question_list":questionList,
            "test_report_id" : testReportID,
            "taken_time" : takenTime
        }
       
        await API.post(API_URL,objValue).then(function (response) {
            
            if (response.status === RESPONSE_SUCCESS) {
                if (response.data.status === "success") {
                    navigate(ROUTE_DASHBOARD);
                    let newURL = RouteChanged(ROUTE_EXAM_SINGLE_REPORT,testReportID)
                    navigate(newURL);
                } else {
                    toast.error(response.data.message);
                    setIsComplete(false);
                }
            }

        }).catch(function (error) {
           // ForceLogoutUser(error);
           setIsComplete(false);
        });
  
    }

    
    const [hour, setHour] = useState(0);
    const [minute, setMinute] = useState(0);
    const [second, setSecond] = useState(0);

    function secondsToTime(secs) {
        var hours = Math.floor(secs / (60 * 60));
        var divisor_for_minutes = secs % (60 * 60);
        var minutes = Math.floor(divisor_for_minutes / 60);
        var divisor_for_seconds = divisor_for_minutes % 60;
        var seconds = Math.ceil(divisor_for_seconds);
        return {
          h: hours,
          m: minutes,
          s: seconds
        };
    }

    useEffect(() => {
        if (takenTime >= 0) {
          const secondsLeft = setInterval(() => {
            setTakenTime((c) => c - 1);
            let timeLeftVar = secondsToTime(takenTime);
            setHour(timeLeftVar.h);
            setMinute(timeLeftVar.m);
            setSecond(timeLeftVar.s);
          }, 1000);
          return () => clearInterval(secondsLeft);
        } else {
            if(loadQuestion) {
                timeUp();
            }
            
        }
    }, [takenTime]);
    
    const timeUp  = async () => {
      console.log("timeout");
        confirmAlert({
            title: 'Time up !',
            message: 'Are you sure to continue?.',
            buttons: [
                {
                label: 'Yes',
                onClick: () =>  completeExam()
                }
            ]
        });
    }

    const clickToComplete  = async () => {
      console.log("timeout");
        confirmAlert({
            title: 'Test Complete !',
            message: 'Are you sure to complete the test ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () =>  completeExam()
                },
                {
                    label: 'No',
                    onClick: () => { return false;}
                }
            ]
        });
    }




    
    return (
        <>
        <div className="overlay"></div>
        <nav className="examPage navbar">
            <div className="container-fluid">
                <div className="navbar-header">
                    <span onClick={showNavigation} className="bars"></span>
                    <Link className="navbar-brand" to={'#'}>{examTitle}</Link>
                </div>
                
            </div>
        </nav>
        <section>
            <aside id="leftsidebar" className="examPage sidebar">
                <div className="user-info bg-cyan" style={ {height:"120px"}}>
                    <div className="row clearfix">
                        {/* <div className="col-xs-6">
                            <button type="button" className="btn btn-primary waves-effect mr-5 exam_option_wh_30">&nbsp;</button> Mark as Review <br/><br/>
                            <button type="button" className="btn btn-warning waves-effect mr-5 exam_option_wh_30">&nbsp;</button> Mark as Report <br/>
                        </div> */}
                        <div className="col-xs-6">
                            <button type="button" className="btn btn-default waves-effect mr-5 exam_option_wh_30">&nbsp;</button> No Answer<br/><br/>
                            <button type="button" className="btn btn-success waves-effect mr-5 exam_option_wh_30">&nbsp;</button> Answered <br/>
                        </div>
                    </div>
                </div>
                
                <div className="menu">
                    <div className="examOption">
                        <div className="row clearfix text-center">
                            {
                                questionList && questionList.map((item) => {
                                    let optionClass = 'btn btn-default waves-effect mr-5'; 
                                    if(item.user_select_option !== '') {
                                        optionClass = 'btn btn-success waves-effect mr-5'; 
                                    }

                                    return (
                                        <>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center" >
                                                <button type="button"  className={optionClass} onClick={() => {goToQuestion(item.question_sr_no, item.question_id)}}>{item.question_sr_no}</button>
                                            </div>
                                        </>
                                    )
                                })
                            } 
                        </div>
                    </div>
                </div>
                <hr/>
                <div className="row text-center">
                    <button 
                        type="button" 
                        className="btn bg-indigo waves-effect" 
                        onClick={() => { clickToComplete()}} 
                        disabled={isComplete}  
                        style={{ cursor: isComplete ? 'not-allowed' : 'pointer' }}    
                    >Complete Now</button>
                </div>
                          
            </aside>
        </section>
        
        <section className="content">
            <div className="container-fluid">
                <div className="text-center">
                    {hour < 9 ? "0" + hour : hour} : {minute < 9 ? "0" + minute : minute} : {second < 9 ? "0" + second : second}
                </div>
                {/* <select>
                    <option value="english">English</option>
                    <option value="Hindi">Hindi</option>
                </select> */}
                {
                    currentQuestionData && currentQuestionData.map((item,key) => {
                        return (
                            <>
                            <div className="block-header">
                                <h2>Question. {currentQuestion}</h2>
                            </div>

                            <div className="row clearfix" key="{key}">

                                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                    <div dangerouslySetInnerHTML={{ __html: item.question_in_english }} />
                                    <div dangerouslySetInnerHTML={{ __html: item.question_in_hindi }} />
                                    
                                    <hr/>
                                    { 
                                       item.options && item.options.map((optionItem,k) => {

                                            let option_key = currentQuestion+'_'+k;

                                            return (
                                                <>
                                                    <div className="input-group input-group-lg quetionOption" >
                                                        <span className="input-group-addon">

                                                            {
                                                               (item.user_select_option === optionItem.option_id) ? (
                                                                <>
                                                                    <input 
                                                                        type="radio" 
                                                                        className="11111" 
                                                                        name="option" 
                                                                        id={option_key}
                                                                        value={optionItem.option_id}
                                                                        onClick={() => tickAsMark(item.question_id,optionItem.option_id)}
                                                                        checked="checked"
                                                                    />
                                                                    <label htmlFor={option_key} ></label>
                                                                </>
                                                               ) : (
                                                                <>
                                                                    <input 
                                                                        type="radio" 
                                                                        className="uncheck 22222" 
                                                                        name="option" 
                                                                        id={option_key}
                                                                        value={optionItem.option_id}
                                                                        onClick={() => tickAsMark(item.question_id,optionItem.option_id)}
                                                                    />
                                                                    <label htmlFor={option_key} className={`label_uncheck label_uncheck_${item.question_id}`}></label>
                                                                </>  
                                                               )
                                                            }
                                                            
                                                        </span>
                                                        <div className="form-line padding_top_13">
                                                            <div dangerouslySetInnerHTML={{ __html: optionItem.option_english }} />
                                                            <div dangerouslySetInnerHTML={{ __html: optionItem.option_hindi }} />
                                                        </div>
                                                    </div>

                                                    
                                                </>
                                            )
                                            
                                       })    
                                    }

                                    
                                
                                </div> 
                            </div>
                            </>
                            )
                        })
                }     
            </div>
        </section>
        
        
        <div className="footerExam">
            <div className="row clearfix">
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 borderRightWhite" onClick={() => handlePageChange(currentQuestion - 1)} >
                    <p className="previousClass">Previous</p>
                </div>    
                
                {
                    (totalQuestionCount === currentQuestion) ? (
                        <> 
                        <div 
                            className="col-lg-6 col-md-6 col-sm-6 col-xs-6" 
                            onClick={() => { clickToComplete()}} 
                            disabled={isComplete}  
                            style={{ cursor: isComplete ? 'not-allowed' : 'pointer' }}  
                        > <p className="nextClass">Complete</p> </div> </>
                        ) : (
                            <>  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6" onClick={() => handlePageChange(currentQuestion + 1)} > <p className="nextClass">Next</p> </div>  </>
                        ) 
                }
                
                
            </div>    
        </div>
        </>
    );
   
}
    
export default ExamPage;